import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

/**
 * 光标 / 选区落在表格内时，给该表格节点加上 .table-focused 类
 * 通过 ProseMirror 装饰实现，不直接改 DOM
 */
export const TableFocus = Extension.create({
    name: 'tableFocus',

    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('tableFocus'),
                props: {
                    decorations(state) {
                        const { $from } = state.selection;
                        for (let depth = $from.depth; depth > 0; depth -= 1) {
                            const node = $from.node(depth);
                            if (node.type.name === 'table') {
                                const pos = $from.before(depth);
                                return DecorationSet.create(state.doc, [
                                    Decoration.node(pos, pos + node.nodeSize, {
                                        class: 'table-focused',
                                    }),
                                ]);
                            }
                        }
                        return DecorationSet.empty;
                    },
                },
            }),
        ];
    },
});

export default TableFocus;
